import { useState } from 'react';
import moment from 'moment';
import { FiUser } from 'react-icons/fi';
import ProposedDphCell from './ProposedDphCell';
import DocumentCell from './DocumentCell';
import ApprovalsStatusModal from './ApprovalsStatusModal';
import RemarksModal from './RemarksModal';
import './ProposalTable.scss';
import { Info } from 'lucide-react';

const ProposalTable = ({
    dphDataList,
    toggleRow,
    selectedRows,
    handleClickSendToApproval,
    onViewRfq,
    handleClickApprove,
    handleClickReject,
    tab,
    branchDocuments,
    onDocumentChange,
    proposedValues,
    handleProposedChange,
    isDownloadExcelEnabled,
    onDownloadExcel,
}) => {
    const [approvalsModal, setApprovalsModal] = useState({ visible: false, list: [] });
    const [remarksModal, setRemarksModal] = useState({ visible: false, title: '', item: null, action: null });

    const openApprovalsModal = (approvalsList) => setApprovalsModal({ visible: true, list: approvalsList });
    const closeApprovalsModal = () => setApprovalsModal({ visible: false, list: [] });

    const openRemarksModal = (item, action) => {
        let title = 'Reject';
        if (action === 'approve') title = 'Approve';
        else if (action === 'sendApproval') title = 'Send for Approval';
        setRemarksModal({ visible: true, title, item, action });
    };
    const closeRemarksModal = () => setRemarksModal({ visible: false, title: '', item: null, action: null });

    const handleRemarksConfirm = (remarks) => {
        if (remarksModal.action === 'approve') {
            handleClickApprove(remarksModal.item, remarks);
        } else if (remarksModal.action === 'sendApproval') {
            handleClickSendToApproval(remarksModal.item, remarks);
        } else {
            handleClickReject(remarksModal.item, remarks);
        }
        closeRemarksModal();
    };

    const shouldRenderStatus = (item) =>{
        if(item?.is_send_approval){
            return "Send For Approval "
        }
        if (item?.is_fully_approved){
            return "Approved"
        }
        
    }

    return (
        <>
        <div className="proposal-table">
            <table>
                <thead>
                    <tr>
                        <th></th>
                        <th>Sl No</th>
                        <th>Branch Name</th>
                        <th>Prev DP</th>
                        <th>System Suggested DP</th>
                        <th>Proposed DPH</th>
                        <th>DP Difference</th>
                        <th>Documents <span className="error-color fs-16">*</span></th>
                        <th>Actions</th>
                        {/* {tab == 0 && <th className="status-col">Status</th>} */}
                    </tr>
                </thead>

                <tbody>
                    {dphDataList.length === 0 ? (
                        <tr>
                            <td colSpan="9" className="no-data">No data available</td>
                        </tr>
                    ) : (
                        dphDataList.map((item, index) => {
                            const prevDP = Number(item.previous_diesel_price || 0);
                            const currDP = Number(item.current_diesel_price || 0);
                            const proposedDP = Number(proposedValues[item.branch_id] ?? item.proposed_diesel_price ?? currDP);
                            const isSelected = selectedRows === item.branch_id;
                            const diff = proposedDP - prevDP;
                            const diffPercent = prevDP
                                ? ((diff / prevDP) * 100).toFixed(2)
                                : '0.00';

                            return (
                                <tr key={item.branch_id}>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={isSelected}
                                            onChange={() => toggleRow(item.branch_id)}
                                        />
                                    </td>

                                    <td>{index + 1}</td>
                                    <td>{item.branch_name}</td>
                                    <td>₹ {prevDP.toFixed(2)}</td>

                                    <td className="link">₹ {currDP.toFixed(2)}</td>

                                    <td>
                                        <ProposedDphCell
                                            branchId={item.branch_id}
                                            currentDP={currDP}
                                            proposedDphPrice={item.proposed_diesel_price}
                                            onChange={(val) => handleProposedChange(item.branch_id, val)}
                                            editable={tab === 0 || item?.actions?.enable_send_approver_action}
                                        />
                                    </td>

                                    <td>
                                        <span className={diff >= 0 ? 'diff up' : 'diff down'}>
                                            {diff >= 0 ? '↗' : '↘'} {Math.abs(diff).toFixed(2)} ({diffPercent}%)
                                        </span>
                                    </td>

                                    <td>
                                        <DocumentCell
                                            documents={branchDocuments[item.branch_id] || []}
                                            branchId={item.branch_id}
                                            onChange={onDocumentChange}
                                            enableUpload={tab === 0 || item?.actions?.enable_send_approver_action}
                                        />
                                    </td>

                                    <td className="actions">
                                        <button
                                            className="primary"
                                            onClick={() => onViewRfq(item)}
                                            disabled={!isSelected}
                                        >
                                            View RFQ
                                        </button>

                                        {isDownloadExcelEnabled && (
                                            <button
                                                className="primary"
                                                disabled={!isSelected}
                                                onClick={() => onDownloadExcel({ ...item, proposed_diesel_price: proposedDP })}
                                            >
                                                Download Excel
                                            </button>
                                        )}

                                        {(tab !== 0 && item?.actions?.enable_send_approver_action && 
                                            <button
                                                className="primary"
                                                disabled={!isSelected}
                                                onClick={() => openRemarksModal(item, 'sendApproval')}
                                            >
                                                Send for Approval
                                            </button>
                                        )}

                                        {(tab == 0 &&
                                            <button
                                                className="primary"
                                                disabled={!isSelected}
                                                onClick={() => openRemarksModal(item, 'sendApproval')}
                                            >
                                                Send for Approval
                                            </button>
                                        )}

                                        {tab !== 0 && item?.approvals_status?.length > 0 && (
                                            <button
                                                className="primary"
                                                disabled={!isSelected}
                                                onClick={() => openApprovalsModal(item.approvals_status)}
                                            >
                                                View Approvals
                                            </button>
                                        )}

                                        {tab === 1 && item?.actions?.enable_approvers_actions && (
                                            <>
                                                <button
                                                    className="primary"
                                                    disabled={!isSelected}
                                                    onClick={() => openRemarksModal(item, 'approve')}
                                                >
                                                    Approve
                                                </button>

                                                <button
                                                    className="primary"
                                                    disabled={!isSelected}
                                                    onClick={() => openRemarksModal(item, 'reject')}
                                                >
                                                    Reject
                                                </button>
                                            </>
                                        )}

                                        {item?.approval_process_logs?.length > 0 && (
                                            <div className="branch-name-cell">
                                                <Info className="approver-logs-icon" />
                                                <div className="approver-tooltip">
                                                    <div className="approver-tooltip__title">Approver Logs</div>
                                                    <div className="approver-tooltip__header">
                                                        <span>Level</span>
                                                        <span>Email</span>
                                                        <span>Action</span>
                                                        <span>Remarks</span>
                                                        <span>Date & Time</span>
                                                    </div>
                                                    {item.approval_process_logs.map((log, i) => (
                                                        <div key={i} className="approver-tooltip__row">
                                                            <span className="approver-tooltip__level">L{log.level}</span>
                                                            <span className="approver-tooltip__email">{log.email}</span>
                                                            <span className="approver-tooltip__action">{log.action}</span>
                                                            <span className="approver-tooltip__remarks">{log.remarks || '—'}</span>
                                                            <span className="approver-tooltip__date">{moment(log.date_time).format('DD MMM YYYY, hh:mm A')}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </td>
                                    {/* {tab == 0 && <td className="status-col">{shouldRenderStatus(item)}</td>} */}
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </table>
        </div>

        <ApprovalsStatusModal
            visible={approvalsModal.visible}
            onClose={closeApprovalsModal}
            approvalsList={approvalsModal.list}
        />

        <RemarksModal
            visible={remarksModal.visible}
            title={remarksModal.title}
            onClose={closeRemarksModal}
            onConfirm={handleRemarksConfirm}
        />
        </>
    );
};

export default ProposalTable;
